(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('product-analysis', {
            parent: 'entity',
            url: '/product-analysis',
            data: {
                authorities: ["ROLE_STATISTICS"],
                pageTitle: 'global.menu.entities.productAnalysis'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-analysis/product-analysis.html',
                    controller: 'ProductAnalysisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }

})();
